<template>
  <v-container>
    <KTCard>
      <template #body>
        <div class="d-flex justify-content-between">
          <b-card-title>لیست تخفیف ها</b-card-title>
        </div>
        <list-table />
      </template>
    </KTCard>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ListTable from "./ListTable";
import KTCard from "../../content/Card";
export default {
  name: "List",
  components: {KTCard, ListTable },
  data() {
    return {};
  }
};
</script>

<style scoped></style>
